import GridViewRoundedIcon from '@mui/icons-material/GridViewRounded';
import ListIcon from '@mui/icons-material/List';
import ViewAgendaIcon from '@mui/icons-material/ViewAgenda';
import { Divider, IconButton, Tooltip } from '@mui/material';
import { viewTypeIconButtonSx } from 'components/Search/styles';
import { Fragment, memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchModalContext } from '../SearchModal';

/**
 * --------------------------------------------------------
 * Generic - View Select Component
 * - List/Summary/Card view selector for search modals
 * --------------------------------------------------------
 */

export const SearchModalViewSelectGeneric = memo(() => {
  const { t } = useTranslation();
  const { view, setView } = useSearchModalContext();

  const isCardView = view === 'card';
  const isSummaryView = view === 'summary';
  const isListView = view === 'list';

  // View Switch Handlers
  const handleSummaryView = useCallback(() => {
    setView('summary');
  }, [setView]);

  const handleListView = useCallback(() => {
    setView('list');
  }, [setView]);

  const handleCardView = useCallback(() => {
    setView('card');
  }, [setView]);

  // Translation strings
  const strCardView = t('blox.search.view.card_view');
  const strSummaryView = t('blox.search.view.summary_view');
  const strListView = t('blox.search.view.list_view');

  return (
    <Fragment>
      <Tooltip
        title={strCardView}
        disableInteractive
      >
        <IconButton
          data-testid="search-modal-card-view"
          aria-label="card-view"
          onClick={handleCardView}
          sx={viewTypeIconButtonSx}
        >
          <GridViewRoundedIcon color={isCardView ? 'primary' : 'disabled'} />
        </IconButton>
      </Tooltip>
      <Divider
        orientation="vertical"
        flexItem
      />
      <Tooltip
        title={strSummaryView}
        disableInteractive
      >
        <IconButton
          data-testid="search-modal-summary-view"
          aria-label="summary-view"
          onClick={handleSummaryView}
          sx={viewTypeIconButtonSx}
        >
          <ViewAgendaIcon color={isSummaryView ? 'primary' : 'disabled'} />
        </IconButton>
      </Tooltip>
      <Divider
        orientation="vertical"
        flexItem
      />
      <Tooltip
        data-testid="search-modal-list-view"
        title={strListView}
        disableInteractive
      >
        <IconButton
          aria-label="list-view"
          onClick={handleListView}
          sx={viewTypeIconButtonSx}
        >
          <ListIcon color={isListView ? 'primary' : 'disabled'} />
        </IconButton>
      </Tooltip>
    </Fragment>
  );
});
SearchModalViewSelectGeneric.displayName = 'SearchModalViewSelectGeneric';
